import { HeyUtils } from "../core";

export class ConversationalService {
    private CONVERSATIONAL_AGGREGATOR_API: string;
    protected heyUtils: HeyUtils;
    
    constructor(heyUtils: HeyUtils) {
        this.heyUtils = heyUtils;
    }

    public async requestAssistantResponse(payload: any): Promise<string> {
        await this.heyUtils.waitInit();
        if (!this.CONVERSATIONAL_AGGREGATOR_API) {
            const userId = this.heyUtils.getUserId();
            const encodedUserId = btoa(String.fromCharCode(
                ...new TextEncoder().encode(userId)));
            this.CONVERSATIONAL_AGGREGATOR_API = this.heyUtils.getConfig().baseUrlConversational + '/' + encodedUserId;
        }
        try {
            const response = await fetch(this.CONVERSATIONAL_AGGREGATOR_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                throw new Error('Failed to call custom endpoint');
            }
            const data = await response.json();
            // Only return the assistant_message field if present
            return data.assistant_message || '';
        } catch (error) {
            console.error('Error calling custom endpoint:', error);
            throw error;
        }
    }
}